<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    meta: {
      type: Object,
      default: () => {
        return {
          title: '',
          icon: ''
        }
      }
    },
    appeal: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    agency: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    purchase: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    sale: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    approval: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    tradePayment: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  render(h, context) {
    const { icon, title, dot, fileDot, noAppeal, noAgency, noPurchase, noSale, noReimbursement, noCashRequirement, customer, contract } = context.props.meta
    const appeal = context.props.appeal
    const agency = context.props.agency
    const purchase = context.props.purchase
    const sale = context.props.sale
    const approval = context.props.approval
    const vnodes = []
    const tradePayment = context.props.tradePayment

    if (icon) {
      vnodes.push(<svg-icon icon-class={icon}/>)
    }
    if (title) {
      if (title === 'Dashboard' && fileDot) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Colin Notes' && dot) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Appeal' && noAppeal) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Agency' && noAgency) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Futures Financial' && (appeal || agency)) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Purchase' && noPurchase) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Sale' && noSale) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Cash Flow' && approval) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Finance' && approval) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Spot Trade' && (purchase || sale)) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Reimbursement' && noReimbursement) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Cash Requirement' && noCashRequirement) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Trade Payment' && tradePayment) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Customer' && customer) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else if (title === 'Contract' && contract) {
        vnodes.push(<span slot='title' class='red-point'>{(title)}</span>)
      } else {
        vnodes.push(<span slot='title'>{(title)}</span>)
      }
    }
    return vnodes
  }
}
</script>

<style>
.red-point{
  position: relative;
}

.red-point::before{
  content: " ";
  border: 3px solid red;/*设置红色*/
  border-radius:3px;/*设置圆角*/
  position: absolute;
  z-index: 1000;
  right: -3px;
  top: 0;
  margin-right: -8px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/Item.vue